import { render, staticRenderFns } from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=template&id=2c3f1b3e&scoped=true"
import script from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=script&lang=js"
export * from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=style&index=0&id=2c3f1b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f1b3e",
  null
  
)

export default component.exports